/* VELISÉ — Fluid interaction layer (v12)

   Was v11 hier hatte: 1:1-Tracking und eine feste Geschwindigkeitsschwelle,
   danach übernahm eine CSS-Transition. Das hat zwei Nahtstellen erzeugt.
   Erstens sprang die Geschwindigkeit beim Loslassen auf die Kurve der
   Transition um — der Finger warf, das Sheet glitt gleichmäßig. Zweitens
   war die Transition nicht greifbar: wer das schließende Sheet wieder fassen
   wollte, musste warten, bis es fertig geschlossen war.

   v12 folgt Apples "Designing Fluid Interfaces": Federn statt Dauern,
   Geschwindigkeitsübergabe beim Loslassen, Momentum-Projektion statt fester
   Schwelle, Gummiband an den Grenzen, und jede Bewegung startet beim aktuell
   sichtbaren Wert — also jederzeit unterbrechbar.

   velise-m.js behält die Hoheit über Zustand, Fokus, Scroll-Lock und
   /cart.js. Diese Datei hört nur zu und bewegt. Fällt sie aus, greifen die
   CSS-Transitionen aus velise-m.css unverändert. */
(function () {
  if (window.__veliseMotion) return;
  window.__veliseMotion = true;

  var MQ = '(max-width: 899.98px)';

  function mobile() {
    return window.matchMedia ? window.matchMedia(MQ).matches : false;
  }
  function reduced() {
    return window.matchMedia
      ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
      : false;
  }
  function supported() {
    return 'PointerEvent' in window &&
           'requestAnimationFrame' in window &&
           'MutationObserver' in window;
  }

  /* =========================================================================
     Feder
     Apple parametrisiert nicht über Masse/Steifigkeit/Dämpfung, sondern über
     zwei Werte, über die sich reden lässt:

       damping  1.0 = kein Überschwingen, < 1.0 schwingt über
       response      wie schnell der Zielwert erreicht wird, in Sekunden

     Eine Feder hat keine Dauer. Wie lange sie braucht, ergibt sich.
     ========================================================================= */
  function spring(opts) {
    var zeta = opts.damping;
    var omega = (2 * Math.PI) / opts.response;
    var k = omega * omega;
    var c = 2 * zeta * omega;

    var x = opts.from - opts.to;      // Auslenkung
    var v = opts.velocity || 0;       // px/s, vom Finger übernommen
    var raf = null;
    var last = null;

    function step(now) {
      if (last === null) last = now;
      /* Beim Tab-Wechsel kann dt sekundenlang sein; ohne Deckel schießt die
         Integration ins Nichts. */
      var dt = Math.min((now - last) / 1000, 1 / 30);
      last = now;

      /* Substeps bei 240 Hz: bei kurzer response und 60-Hz-Frames wäre ein
         einzelner Euler-Schritt instabil. */
      var steps = Math.max(1, Math.ceil(dt * 240));
      var h = dt / steps;
      for (var i = 0; i < steps; i++) {
        var a = -k * x - c * v;
        v += a * h;
        x += v * h;
      }

      if (Math.abs(x) < 0.5 && Math.abs(v) < 5) {
        opts.onFrame(opts.to, 0);
        if (opts.onDone) opts.onDone();
        return;
      }
      opts.onFrame(opts.to + x, v);
      raf = requestAnimationFrame(step);
    }

    raf = requestAnimationFrame(step);

    return {
      cancel: function () { if (raf) cancelAnimationFrame(raf); },
      velocity: function () { return v; }
    };
  }

  /* Wohin trägt der Schwung? Exponentieller Zerfall, wie beim Scrollen.
     Nicht die Lehrbuchformel v^2/(2a) — das ist nicht, was sich richtig
     anfühlt und nicht, was Apple ausliefert. */
  function project(velocity, rate) {
    rate = rate || 0.998;
    return (velocity / 1000) * rate / (1 - rate);
  }

  /* Gummiband: je weiter über die Grenze, desto weniger folgt das Element.
     Eine harte Wand liest sich als eingefroren, nachgebender Widerstand als
     "reagiert, aber hier ist nichts mehr". */
  function rubberband(overshoot, dimension, constant) {
    constant = constant || 0.55;
    return (overshoot * dimension * constant) /
           (dimension + constant * Math.abs(overshoot));
  }

  /* Geschwindigkeit aus den letzten ~100 ms, nicht aus dem ganzen Zug.
     Wer langsam zieht und dann schnippt, hat im Mittel eine kleine
     Geschwindigkeit — gemeint war aber der Schnipp. */
  function Tracker() {
    var pts = [];
    return {
      add: function (y) {
        var now = performance.now();
        pts.push({ y: y, t: now });
        while (pts.length > 2 && now - pts[0].t > 100) pts.shift();
      },
      reset: function () { pts.length = 0; },
      velocity: function () {
        if (pts.length < 2) return 0;
        var a = pts[0], b = pts[pts.length - 1];
        var dt = (b.t - a.t) / 1000;
        if (dt <= 0) return 0;
        return (b.y - a.y) / dt;
      }
    };
  }

  /* =========================================================================
     Ein greifbares, federgetriebenes Panel, das von unten kommt.
     ========================================================================= */
  function fluidPanel(el, cfg) {
    var current = 0;         // aktuelle Verschiebung in px, 0 = offen
    var anim = null;
    var pointerId = null;
    var grabbedAt = 0;
    var startY = 0;
    var dismissing = false;  // die Geste hat den Schluss schon eingeleitet
    var track = Tracker();

    function closedAt() { return el.offsetHeight || window.innerHeight; }

    function paint(y) {
      current = y;
      el.style.transform = cfg.transform(y);
    }

    function stop() {
      if (anim) { anim.cancel(); anim = null; }
    }

    function springTo(to, velocity, damping) {
      stop();
      if (reduced()) { paint(to); if (to !== 0) cfg.onClosed(); return; }
      anim = spring({
        from: current,
        to: to,
        velocity: velocity || 0,
        /* Kein Überschwingen, wenn kein Schwung vorausging. Ein Sheet, das
           nach einem Tap nachwippt, wirkt gebaut; eines, das nach einem
           Wurf nachwippt, wirkt physikalisch. */
        damping: damping || 1.0,
        response: 0.3,
        onFrame: function (y) { paint(y); },
        onDone: function () {
          anim = null;
          if (to !== 0) { dismissing = false; cfg.onClosed(); }
        }
      });
    }

    /* --- vom Zustand getrieben: velise-m.js kippt data-open, wir bewegen --- */
    function openNow() {
      dismissing = false;
      el.style.visibility = 'visible';
      if (!anim && current === 0) paint(closedAt());
      springTo(0, anim ? anim.velocity() : 0, 1.0);
    }
    function closeNow() {
      /* Hat die Geste den Schluss schon angeworfen, läuft dort bereits eine
         Feder mit der Fingergeschwindigkeit. Sie hier zu ersetzen würde die
         Geschwindigkeit glattbügeln — genau die Naht, die wir loswerden. */
      if (dismissing) return;
      springTo(closedAt(), anim ? anim.velocity() : 0, 1.0);
    }

    /* --- Geste --- */
    var handle = cfg.handle || el;

    handle.addEventListener('pointerdown', function (e) {
      if (pointerId !== null) return;                  // Multi-Touch-Schutz
      if (!cfg.active()) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (e.target.closest && e.target.closest('button, a, input, select, textarea')) return;

      /* Eine laufende Animation wird nicht abgewartet, sondern gegriffen —
         beim aktuell sichtbaren Wert, nicht beim Zielwert. */
      stop();
      dismissing = false;

      pointerId = e.pointerId;
      startY = e.clientY;
      grabbedAt = current;
      track.reset();
      track.add(e.clientY);
      el.setAttribute('data-dragging', 'true');
      try { handle.setPointerCapture(pointerId); } catch (err) {}
    });

    handle.addEventListener('pointermove', function (e) {
      if (e.pointerId !== pointerId) return;
      track.add(e.clientY);

      var y = grabbedAt + (e.clientY - startY);
      if (y < 0) y = rubberband(y, closedAt());        // nach oben: nachgeben
      paint(y);
    });

    handle.addEventListener('pointerup', function (e) {
      if (e.pointerId !== pointerId) return;
      try { handle.releasePointerCapture(e.pointerId); } catch (err) {}
      pointerId = null;
      el.removeAttribute('data-dragging');

      var v = track.velocity();
      /* Nicht "wie weit ist es gezogen", sondern "wohin trägt der Schwung".
         Ein kurzer Schnipp aus wenigen Pixeln wirft das Sheet damit genauso
         zu wie ein langer Zug. */
      var landing = current + project(v);

      if (landing > closedAt() / 2) {
        dismissing = true;
        springTo(closedAt(), v, 0.8);   // nach einem Wurf darf es nachwippen
        cfg.onDismiss();                // Zustandswechsel, Feder läuft weiter
      } else {
        /* Zurück in die offene Lage immer kritisch gedämpft. Überschwingen
           hieße hier: das Sheet hebt kurz über die Unterkante des Bildschirms
           und darunter blitzt der Hintergrund durch. Nachwippen ist nur dort
           richtig, wo das Element ohnehin aus dem Bild fliegt. */
        springTo(0, v, 1.0);
      }
    });

    handle.addEventListener('pointercancel', function (e) {
      if (e.pointerId !== pointerId) return;
      try { handle.releasePointerCapture(e.pointerId); } catch (err) {}
      pointerId = null;
      el.removeAttribute('data-dragging');
      springTo(0, 0, 1.0);
    });

    return {
      open: openNow,
      close: closeNow,
      reset: function () { stop(); paint(closedAt()); }
    };
  }

  /* --------------------------- Cart-Sheet --------------------------- */
  function wireSheet() {
    var sheet = document.querySelector('[data-vel-sheet]');
    if (!sheet || sheet.__velFluid) return;
    var head = sheet.querySelector('.vel-sheet__head');
    if (!head) return;
    sheet.__velFluid = true;

    try {
      var panel = fluidPanel(sheet, {
        handle: head,
        active: function () {
          return mobile() && sheet.getAttribute('data-open') === 'true';
        },
        transform: function (y) { return 'translateY(' + y + 'px)'; },
        onDismiss: function () {
          var close = sheet.querySelector('[data-vel-cart-close]');
          if (close) close.click();
        },
        onClosed: function () { sheet.style.visibility = 'hidden'; }
      });

      panel.reset();

      var open = sheet.getAttribute('data-open') === 'true';
      if (open) panel.open();

      new MutationObserver(function () {
        var now = sheet.getAttribute('data-open') === 'true';
        if (now === open) return;
        open = now;
        if (!mobile()) return;
        if (now) panel.open(); else panel.close();
      }).observe(sheet, { attributes: true, attributeFilter: ['data-open'] });

      /* Erst jetzt gibt CSS seine eigene Transition ab. Wäre das Flag oben
         gesetzt worden und hier etwas fehlgeschlagen, hätte das Sheet weder
         Transition noch Feder — es stünde still. */
      sheet.setAttribute('data-spring', 'on');
    } catch (err) {
      sheet.removeAttribute('data-spring');
      sheet.style.transform = '';
    }
  }

  /* ------------------------------ Toast ------------------------------ */
  function wireToast() {
    var toast = document.querySelector('[data-vel-toast]');
    if (!toast || toast.__velFluid) return;
    toast.__velFluid = true;

    var current = 0, anim = null, pointerId = null;
    var startY = 0, grabbedAt = 0;
    var track = Tracker();
    var TRAVEL = 90;   /* Weg bis "weg" — der Toast ist klein, er fällt kurz */

    function paint(y) {
      current = y;
      toast.style.transform = 'translateX(-50%) translateY(' + y + 'px)';
    }
    function stop() { if (anim) { anim.cancel(); anim = null; } }

    function settle(to, v, damping) {
      stop();
      if (reduced()) { paint(to); return; }
      anim = spring({
        from: current, to: to, velocity: v || 0,
        damping: damping || 1.0, response: 0.28,
        onFrame: paint,
        onDone: function () { anim = null; }
      });
    }

    try {
      toast.addEventListener('pointerdown', function (e) {
        if (pointerId !== null) return;
        if (!mobile() || toast.getAttribute('data-on') !== 'true') return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        stop();
        pointerId = e.pointerId;
        startY = e.clientY;
        grabbedAt = current;
        track.reset(); track.add(e.clientY);
        toast.setAttribute('data-dragging', 'true');
        try { toast.setPointerCapture(pointerId); } catch (err) {}
      });

      toast.addEventListener('pointermove', function (e) {
        if (e.pointerId !== pointerId) return;
        track.add(e.clientY);
        var y = grabbedAt + (e.clientY - startY);
        if (y < 0) y = rubberband(y, TRAVEL);
        paint(y);
      });

      toast.addEventListener('pointerup', function (e) {
        if (e.pointerId !== pointerId) return;
        try { toast.releasePointerCapture(e.pointerId); } catch (err) {}
        pointerId = null;
        toast.removeAttribute('data-dragging');

        var v = track.velocity();
        if (current + project(v) > TRAVEL / 2) {
          toast.setAttribute('data-on', 'false');
          settle(TRAVEL, v, 0.8);
        } else {
          settle(0, v, 1.0);   // zurück in die Ruhelage: kein Überschwingen
        }
      });

      toast.addEventListener('pointercancel', function (e) {
        if (e.pointerId !== pointerId) return;
        pointerId = null;
        toast.removeAttribute('data-dragging');
        settle(0, 0, 1.0);
      });

      /* Kommt der Toast neu, startet er wieder unten — gleiche Richtung rein
         wie raus, sonst geht der räumliche Zusammenhang verloren. */
      new MutationObserver(function () {
        if (toast.getAttribute('data-on') === 'true' && pointerId === null && current !== 0) {
          stop();
          paint(12);
          settle(0, 0, 1.0);
        }
      }).observe(toast, { attributes: true, attributeFilter: ['data-on'] });

      toast.setAttribute('data-spring', 'on');
    } catch (err) {
      toast.removeAttribute('data-spring');
      toast.style.transform = '';
    }
  }

  /* -------------------- Scroll-Kante statt Trennlinie --------------------
     Eine 1px-Linie unter dem Header ist immer da, auch wenn nichts darunter
     liegt. Die Kante soll erst entstehen, wenn Inhalt unter das schwebende
     Material fährt. */
  function wireHeaderEdge() {
    var head = document.querySelector('.v2-head');
    if (!head || head.__velEdge) return;
    head.__velEdge = true;

    var ticking = false;
    function update() {
      head.setAttribute('data-scrolled', window.scrollY > 4 ? 'true' : 'false');
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }, { passive: true });
    update();
  }

  function init() {
    if (!supported()) return;
    wireSheet();
    wireToast();
    wireHeaderEdge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
